namespace $.$$ {

	export class $shm_hitalama_opencode_map_sessions extends $.$shm_hitalama_opencode_map_sessions {

		static sessions_data_cache = new Map< string, $shm_hitalama_opencode_api_session[] >()

		@ $mol_mem_key
		static sessions_version( server_url: string, next?: number ) {
			return next ?? 0
		}

		static session_upsert_global( server_url: string, session: $shm_hitalama_opencode_api_session ) {
			if( !session?.id ) return
			const sessions = this.sessions_data_cache.get( server_url ) ?? []
			const index = sessions.findIndex( item => item.id === session.id )
			const next = index === -1
				? [ session, ... sessions ]
				: [ ... sessions.slice( 0, index ), { ... sessions[ index ], ... session }, ... sessions.slice( index + 1 ) ]
			this.sessions_data_cache.set( server_url, next )
			this.sessions_version( server_url, Date.now() )
		}

		static session_from_event( props: any ) {
			return props?.info ?? props?.session ?? props
		}

		@ $mol_action
		static sessions_refresh_global( server_url: string ) {
			$shm_hitalama_opencode_api.sessions( server_url )
				.then( sessions => {
					this.sessions_data_cache.set( server_url, sessions as $shm_hitalama_opencode_api_session[] )
					this.sessions_version( server_url, Date.now() )
				} )
				.catch( error => $mol_fail_log( error ) )
		}

		map() {
			const id = this.map_id()
			if( !id ) return null
			return $giper_baza_glob.Pawn( new $giper_baza_link( id ), $shm_hitalama_map )
		}

		map_title() {
			const map = this.map()
			return map?.title() || map?.link().str || 'Карта'
		}

		opencode_session_ids( next?: readonly string[] ): readonly string[] {
			const map = this.map()
			if( !map ) return []
			if( next !== undefined ) {
				map.store( 'opencode_session_ids', [ ... next ] )
				return next
			}

			const value = map.store( 'opencode_session_ids' )
			if( Array.isArray( value ) ) return value.filter( item => typeof item === 'string' && item )
			if( typeof value === 'string' ) {
				try {
					const parsed = JSON.parse( value )
					if( Array.isArray( parsed ) ) return parsed.filter( item => typeof item === 'string' && item )
				} catch( error ) {
					return []
				}
			}
			return []
		}

		@ $mol_mem
		sessions_data( next?: $shm_hitalama_opencode_api_session[] ) {
			const server_url = this.server_url()
			if( next !== undefined ) {
				$shm_hitalama_opencode_map_sessions.sessions_data_cache.set( server_url, next )
				$shm_hitalama_opencode_map_sessions.sessions_version( server_url, Date.now() )
				return next
			}
			$shm_hitalama_opencode_map_sessions.sessions_version( server_url )
			const cached = $shm_hitalama_opencode_map_sessions.sessions_data_cache.get( server_url )
			if( cached ) return cached
			const sessions = $mol_wire_sync( $shm_hitalama_opencode_api ).sessions( server_url ) as $shm_hitalama_opencode_api_session[]
			$shm_hitalama_opencode_map_sessions.sessions_data_cache.set( server_url, sessions )
			return sessions
		}

		sessions_cached(): $shm_hitalama_opencode_api_session[] {
			return $mol_wire_probe( ()=> this.sessions_data() ) ?? []
		}

		sessions() {
			return this.opencode_session_ids()
				.map( id => this.session_by_id( id ) ?? { id } )
				.filter( Boolean ) as $shm_hitalama_opencode_api_session[]
		}

		session_rows() {
			return this.sessions().map( session => this.Session_row( session.id ) )
		}

		session_by_id( id: string ) {
			return this.sessions_data().find( session => session.id === id )
		}

		session_title( id: string ) {
			const session = this.session_by_id( id )
			return session?.title || session?.slug || id
		}

		session_current_title() {
			const id = this.session_id()
			return id ? this.session_title( id ) : 'Сессии'
		}

		override session_current( id: string ) {
			return this.session_id() === id
		}

		override session_select( id: string, next?: any ) {
			if( next === undefined ) return null
			this.session_id( id )
			return next
		}

		override new_session( next?: any ) {
			if( next === undefined ) return null
			const session = $mol_wire_sync( $shm_hitalama_opencode_api ).create_session(
				this.server_url(),
				null,
				this.new_session_model(),
			) as $shm_hitalama_opencode_api_session

			this.opencode_session_attach( session.id )
			this.session_upsert( session )
			this.session_id( session.id )
			return next
		}

		opencode_session_attach( session_id: string ) {
			const ids = this.opencode_session_ids()
			if( ids.includes( session_id ) ) return ids
			return this.opencode_session_ids( [ session_id, ... ids ] )
		}

		session_upsert( session: $shm_hitalama_opencode_api_session ) {
			if( !session?.id ) return
			const sessions = this.sessions_cached()
			const index = sessions.findIndex( item => item.id === session.id )
			const next = index === -1
				? [ session, ... sessions ]
				: [ ... sessions.slice( 0, index ), { ... sessions[ index ], ... session }, ... sessions.slice( index + 1 ) ]
			this.sessions_data( next )
		}

	}

}
